import React from "react";
import CoinDashboard from '../RJ_coin_game/CoinDashboard';

export default class Coin extends React.Component{

    render(){
        return(
            <CoinDashboard/>
        )
    }}